import { Component, OnInit, ElementRef, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../shared/models/datatables-response';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment'
import { OpportunityOfferOutputModel } from '../shared/models/OpportunityOfferOutputModel'
import { PropertyManagementService } from '../shared/providers/property-management.service';
import { ILookUp } from '../shared/models/LookUpOutputModel';
import { CommonService } from '../shared/providers/common.service';
import { ToastService } from '../shared/providers/toast.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../shared/providers/validation.service';
import { Subscription } from 'rxjs';

export enum Tabs {
  Inquiries = 1,
  Inquiries1031 = 2
}

@Component({
  selector: 'my-inquiry-list',
  templateUrl: './my-inquiry-listing.component.html',

})
export class MyInquiryListComponent implements OnInit, OnDestroy {
  protected readonly BASE_URL: string = environment.base_url;
  dtOptions = {};
  tabs = Tabs;
  currentTab = Tabs.Inquiries;
  table: DataTableDirective;
  offers: OpportunityOfferOutputModel[];
  statusList: ILookUp[];
  modalRef: BsModalRef;
  subscriptions: Subscription[] = [];
  selectedInquiryId: number;
  currentIndex: number;
  user: any;
  isBuy = true;
  brokerDisable1031Prioncipal: boolean = false;
  IsLoading = false;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;


  constructor(private modalService: BsModalService, private http: HttpClient, public authService: AuthenticationService, private _propertyManagerService: PropertyManagementService,
    protected activatedRoute: ActivatedRoute, private router: Router, private _toastService: ToastService,
    private _commonService: CommonService, public valdateService: ValidationService) {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (this.router.url.indexOf('received-inquiries') > -1) {
        this.isBuy = false;
      }
      else {
        this.isBuy = true;
      }
      if (this.valdateService.IsValid(params["activetab"])) {
        this.currentTab = parseInt(params["activetab"]);
      }
    });
  }

  downloadFile = function (downloadPath) {
    this._propertyManagerService.DownloadFile(downloadPath).subscribe(response => {

    });
  }
  deleteInquiry() {
    var inquiryId = this.selectedInquiryId;
    var index = this.currentIndex;
    if (inquiryId > 0) {
      this._propertyManagerService.deleteInquiry(inquiryId).subscribe(response => {
        if (response.toString() == 'true') {
          this.offers.splice(index, 1);
          this._toastService.addToast({
            title: 'Success', msg:
              'Inquiry deleted successfully', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
          });
        }
        else {
          this._toastService.addToast({
            title: 'Error', msg:
              'Error deleting inquiry', timeout:
              5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
          });
        }

      });
    }
  }
  rowCount = 0;
  ngOnInit() {
    this.subscriptions.push(this._commonService.getLookupsByTypeId(17).subscribe(response => {
      this.statusList = response.map(o => {
        return {
          id: o.Id, description: o.Description
        };
      });
    }));
    this.user = this.authService.user;
    var loggedinUserId = this.user.Id;
    const that = this;
    if (this.authService.IsUserRole(this.authService.UserRole.Principal1031)) {
      this.brokerDisable1031Prioncipal = true;
    }
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      bLengthChange: false,
      "order": [[4, "desc"]],
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const httpHeader = this.valdateService.GetAuthHeader();
        this.subscriptions.push(that.http
          .post<DataTablesResponse>(
            this.BASE_URL + '/opportunity/myInquiries/' + loggedinUserId + "/" + this.isBuy,
            dataTablesParameters, httpHeader
          ).subscribe(resp => {
            that.offers = resp.data ? resp.data : [];
            this.rowCount = resp.recordsTotal;
            if (resp) {
              callback({
                recordsTotal: resp.recordsTotal,
                recordsFiltered: resp.recordsFiltered,
                data: []
              });
              if (resp.data.length === 0) {
                $(".dataTables_paginate.paging_full_numbers").hide();
              }
              else {
                $(".dataTables_paginate.paging_full_numbers").show();
              }
              $(".paginate_button.first,.paginate_button.last").hide();
            } else {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            this.IsLoading = false;
          }));
      },
      columns: [
        { data: 'TenantName' },
        { data: 'LeadName' },
        { data: 'PrimaryContactName' },
        { data: 'Comments' },
        { data: 'InquiryDate' },
        { data: 'StatusName' }
      ]
    };
  }
  inquiryList = [];
  trackByFn(i: number) {
    return i;
  }
  changeInquiryStatus(statusId: number, inquiryId: number, i: number, statusName: string) {

    this._propertyManagerService.changeInquiryStatus(statusId, inquiryId).subscribe(response => {
      if (response.toString() == 'true') {


        this._toastService.addToast({
          title: 'Success', msg:
            'Status updated successfully', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'
        });

        for (var i = 0; i < this.offers.length; i++) {
          if (this.offers[i].InquiryId == inquiryId) {
            this.offers[i].StatusName = statusName;
          }
        }

      }
      else {
        this._toastService.addToast({
          title: 'Error', msg:
            'Error updating status', timeout:
            5000, theme: 'bootstrap', position: 'bottom-right', type: 'error'
        });
      }

    });
    event.preventDefault();

  }
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }

  convertUTCDateToLocalDate(InquiryDate: Date) {
    var newDate = new Date(InquiryDate);
    var offset = newDate.getTimezoneOffset() / 60;
    var offsetTime = new Date(newDate.getTime() - (offset * 60 * 1000 * 60));
    return offsetTime;
  }

  openModal(template: TemplateRef<any>, classes: any, id: number, index: number) {
    this.modalRef = this.modalService.show(template, { class: classes });
    this.selectedInquiryId = id;
    this.currentIndex = index;
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  onTabClick(tab) {
    this.currentTab = tab;
    this.router.navigateByUrl(this.valdateService.changeQueryStringValue('activetab', tab));
  }

  archivepropertyMessage() {
    this._toastService.addToast({ title: 'Property Not Available', msg: "The property you are trying to view is not available", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
  }

  ngOnDestroy() {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    });
  }
}
